import { render } from "./InviteUser.vue?vue&type=template&id=6562c78a&scoped=true"
import script from "./InviteUser.vue?vue&type=script&lang=js"
export * from "./InviteUser.vue?vue&type=script&lang=js"

import "./InviteUser.vue?vue&type=style&index=0&id=6562c78a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6562c78a"]])

export default __exports__